export default "__VITE_ASSET__C2rXM5JP__"